var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "import-prepare-step" },
    [
      _c("Preloader", { attrs: { display: _vm.loading } }),
      _vm._v(" "),
      _vm.getTypeImport.is_enabled
        ? _c("CompassAlert", {
            attrs: {
              type: "neutral",
              description: _vm.alertDescription,
              action: {
                label: _vm.alertLabel,
                callback: function() {
                  return _vm.onGoToOldImport()
                }
              },
              showClose: false
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "documentation-caption typographies-paragraph-medium-semibold"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$l10n.__(
                  "Avant de commencer votre import, merci de prendre connaissance de l’ensemble des informations disponibles sur cette page."
                )
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "documentation-link typographies-paragraph-medium-semibold"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$l10n.__("Besoin d’aide ?")) +
              "\n        "
          ),
          _c("CompassLink", {
            attrs: {
              link: "https://help.sellsy.com/fr/?q=import",
              target: "blank",
              label: _vm.$t.__("common.actions.view_import_data_articles")
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "typographies-heading-h2" }, [
        _vm._v(
          "\n        " + _vm._s(_vm.$l10n.__("Modèle de fichier")) + "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "model-caption typographies-paragraph-medium-regular" },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$l10n.__(
                  "Pour vous assurer que la structure des données que vous allez importer dans Sellsy est conforme, téléchargez le modèle et faites correspondre vos données."
                )
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "file-model-block" }, [
        _c(
          "div",
          { staticClass: "type-import-container" },
          [
            _vm.isImportTitleSimple
              ? _c("CompassObject", {
                  attrs: {
                    size: "small",
                    label: _vm.getTypeImport.title,
                    object: _vm.importTypeObject
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.getTypeImport.titleSegments !== undefined
              ? _c(
                  "div",
                  { staticClass: "compass-object compass-object--small" },
                  [
                    _c("CompassIcon", {
                      attrs: { icon: _vm.getTypeImport.icon, size: "medium" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "compass-object__text" }, [
                      _c(
                        "h4",
                        _vm._l(_vm.getTypeImport.titleSegments, function(
                          segment,
                          idx
                        ) {
                          return _c(
                            "span",
                            { class: _vm.getImportTitleClasses(idx) },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.getImportTitleSegmentText(idx, segment)
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons-container" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__(
                  "settings.import.ImportPrepareStep.download_xlsx_template"
                ),
                type: "secondary",
                loading: _vm.isDownloadingXlsxTemplate
              },
              on: {
                click: function($event) {
                  return _vm.onDownloadTemplate("xlsx")
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__(
                  "settings.import.ImportPrepareStep.download_csv_template"
                ),
                type: "secondary",
                loading: _vm.isDownloadingCsvTemplate
              },
              on: {
                click: function($event) {
                  return _vm.onDownloadTemplate("csv")
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "typographies-heading-h2" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Tableau récapitulatif des données")))
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "table-caption typographies-paragraph-medium-regular" },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$l10n.__(
                  "Ce tableau récapitule les données que vous pouvez importer dans Sellsy."
                )
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "mandatory-caption typographies-paragraph-medium-regular"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$l10n.__(
                  "Les données obligatoires sont indiquées par un fond jaune et doivent être complétées afin que l’import puisse aboutir."
                )
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      !_vm.rateCategoriesForImport.length && _vm.hasNoDataForSetupStepMsg !== ""
        ? _c("CompassAlert", {
            attrs: {
              type: "error",
              description: _vm.hasNoDataForSetupStepMsg,
              action: {
                label: _vm.$t.__("common.actions.access_online_help"),
                callback: function() {
                  return _vm.onGoToHelpPage()
                }
              },
              showClose: false
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasDuplicatesRateCategoriesMsg !== ""
        ? _c("CompassAlert", {
            attrs: {
              type: "warning",
              description: _vm.hasDuplicatesRateCategoriesMsg,
              showClose: false
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          staticClass: "import-dialog",
          attrs: {
            visible: _vm.isModalComplexCFVisible,
            bodyScroll: "",
            title: _vm.complexCFDialogTitle
          },
          on: {
            "update:visible": function($event) {
              _vm.isModalComplexCFVisible = $event
            },
            closed: _vm.closeModal
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c(
              "p",
              { staticClass: "subtext typographies-paragraph-medium-regular" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.localizedTexts.commaSeparatedValues) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "import-buttons bottom_interval" },
              _vm._l(_vm.modalComplexCFItems, function(val, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "import-buttons__item" },
                  [
                    _c(
                      "CompassTooltip",
                      {
                        attrs: {
                          content: _vm.localizedTexts.copyValue,
                          placement: "bottom"
                        }
                      },
                      [
                        _c(
                          "CompassTag",
                          {
                            directives: [
                              {
                                name: "clipboard",
                                rawName: "v-clipboard:copy",
                                value: val.label,
                                expression: "val.label",
                                arg: "copy"
                              },
                              {
                                name: "clipboard",
                                rawName: "v-clipboard:success",
                                value: _vm.onCopy,
                                expression: "onCopy",
                                arg: "success"
                              }
                            ],
                            staticClass: "import-buttons__tag"
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(val.label) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              0
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          staticClass: "import-dialog",
          attrs: {
            visible: _vm.isModalAccountingCodesVisible,
            bodyScroll: "",
            title: _vm.accountingCodesDialogTitle
          },
          on: {
            "update:visible": function($event) {
              _vm.isModalAccountingCodesVisible = $event
            },
            closed: _vm.closeModal
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c(
              "div",
              { staticClass: "import-buttons bottom_interval" },
              _vm._l(_vm.modalAccountingCodesItems, function(accountingCode) {
                return _c(
                  "div",
                  {
                    key: accountingCode.code,
                    staticClass: "import-buttons__item"
                  },
                  [
                    _c(
                      "CompassTooltip",
                      {
                        attrs: {
                          content: _vm.localizedTexts.copyValue,
                          placement: "bottom"
                        }
                      },
                      [
                        _c(
                          "CompassTag",
                          {
                            directives: [
                              {
                                name: "clipboard",
                                rawName: "v-clipboard:copy",
                                value: accountingCode.code,
                                expression: "accountingCode.code",
                                arg: "copy"
                              },
                              {
                                name: "clipboard",
                                rawName: "v-clipboard:success",
                                value: _vm.onCopy,
                                expression: "onCopy",
                                arg: "success"
                              }
                            ],
                            staticClass: "import-buttons__tag"
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(accountingCode.code) +
                                " - " +
                                _vm._s(accountingCode.label) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              0
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.categoriesLength > 1
        ? _c(
            "div",
            {
              ref: "tabCategories",
              staticClass: "tab-categories typographies-heading-h4"
            },
            [
              _c(
                "div",
                {
                  class: { selected: _vm.categorySelected === "all" },
                  on: {
                    click: function($event) {
                      return _vm.onClickTab("all")
                    }
                  }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$l10n.__("Toutes")))]),
                  _vm._v(" "),
                  _c("CompassFlag", {
                    attrs: {
                      size: "small",
                      label: _vm.rowsFromDictionary.length
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.categories, function(category, key) {
                return _c(
                  "div",
                  {
                    key: key,
                    class: { selected: _vm.categorySelected === key },
                    on: {
                      click: function($event) {
                        return _vm.onClickTab(key)
                      }
                    }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(category.title))]),
                    _vm._v(" "),
                    _c("CompassFlag", {
                      attrs: {
                        size: "small",
                        label: _vm.getNumberByCategory(key)
                      }
                    })
                  ],
                  1
                )
              }),
              _vm._v(" "),
              Object.keys(_vm.customFieldCategories).length !== 0
                ? _c(
                    "div",
                    {
                      class: {
                        selected: _vm.categorySelected === "customField"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onClickTab("customField")
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$l10n.__("Champs personnalisés")))
                      ]),
                      _vm._v(" "),
                      _c("CompassFlag", {
                        attrs: {
                          size: "small",
                          label: _vm.numberOfCustomFields
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "CustomTable",
        { class: { "border-radius-tl-0": _vm.categoriesLength > 1 } },
        [
          _c("template", { slot: "header" }, [
            _c(
              "th",
              {
                ref: "customTableThead",
                staticClass: "col-label typographies-paragraph-medium-bold"
              },
              [
                _c("span", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$l10n.__("Donnée")) +
                      "\n                "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass:
                  "col-description typographies-paragraph-medium-bold"
              },
              [
                _c("span", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$l10n.__("Description")) +
                      "\n                "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "col-mandatory typographies-paragraph-medium-bold"
              },
              [
                _c("span", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$l10n.__("Obligatoire")) +
                      "\n                "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "th",
              { staticClass: "col-value typographies-paragraph-medium-bold" },
              [
                _c("span", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$l10n.__("Valeur")) +
                      "\n                "
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "content" },
            _vm._l(_vm.dataTable, function(item, itemKey) {
              return _c(
                "tr",
                {
                  key: itemKey,
                  class: {
                    "mandatory-row": item.mandatory,
                    "disabled-row": item.disabled
                  }
                },
                [
                  item.subtitle
                    ? _c(
                        "td",
                        {
                          staticClass:
                            "sub-header-table-recap typographies-paragraph-medium-semibold",
                          style: _vm.customStyleSubHeader,
                          attrs: { colspan: "4" }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.subtitle) +
                              "\n                    "
                          ),
                          item.subheading
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "typographies-paragraph-medium-semibold"
                                },
                                [_vm._v(_vm._s(item.subheading))]
                              )
                            : _vm._e()
                        ]
                      )
                    : [
                        _c(
                          "td",
                          {
                            staticClass:
                              "td-data typographies-paragraph-medium-semibold"
                          },
                          [
                            _c(
                              "CompassTooltip",
                              {
                                attrs: {
                                  content: item.dataTooltip,
                                  disabled: item.dataTooltip === null,
                                  contentClass: "tooltip-import-popup",
                                  placement: "right"
                                }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "typographies-paragraph-medium-regular"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(item.label) +
                                        "\n                                "
                                    ),
                                    item.dataTooltip
                                      ? _c("CompassIcon", {
                                          attrs: {
                                            size: "small",
                                            icon: "info-circle-fill"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "td-description" }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "typographies-paragraph-medium-regular"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.getTextFromHtml(item.description.text)
                                  ) +
                                  "\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          item.description.subtext
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "subtext typographies-paragraph-small-regular"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.description.subtext) +
                                      "\n                        "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "td-mandatory" },
                          [
                            _c(
                              "CompassTooltip",
                              {
                                attrs: {
                                  content: item.mandatoryTooltip,
                                  disabled: item.mandatoryTooltip === undefined,
                                  contentClass:
                                    "tooltip-import-popup " +
                                    (item.mandatoryTooltipClass || ""),
                                  placement: "right"
                                }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "typographies-paragraph-medium-regular"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("booleanFilter")(
                                            item.mandatory
                                          )
                                        ) +
                                        "\n\n                                "
                                    ),
                                    item.mandatoryTooltip
                                      ? _c("CompassIcon", {
                                          attrs: {
                                            type: "warning",
                                            size: "small",
                                            icon: "warning-fill"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass:
                              "td-value typographies-paragraph-medium-regular"
                          },
                          [
                            ["checkbox", "radio", "select"].includes(
                              item.value.text
                            )
                              ? [
                                  _c("p", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.getValueLabel(item.value.text)
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  item.value.description
                                    ? _c("p", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(item.value.description) +
                                            "\n                            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "subtext typographies-paragraph-medium-regular"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.localizedTexts
                                              .commaSeparatedValues
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "import-buttons" },
                                    _vm._l(
                                      item.parameters.items.slice(0, 3),
                                      function(val, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "import-buttons__item"
                                          },
                                          [
                                            _c(
                                              "CompassTooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    _vm.localizedTexts
                                                      .copyValue,
                                                  placement: "bottom"
                                                }
                                              },
                                              [
                                                _c(
                                                  "CompassTag",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:copy",
                                                        value: val.label,
                                                        expression: "val.label",
                                                        arg: "copy"
                                                      },
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:success",
                                                        value: _vm.onCopy,
                                                        expression: "onCopy",
                                                        arg: "success"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "import-buttons__tag"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(val.label) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _vm._v(" "),
                                  item.parameters.items.length > 3
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "import-buttons__tertiary",
                                          on: {
                                            click: function($event) {
                                              return _vm.showModalComplexCF(
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.localizedTexts.showAllValues
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : item.valueFrom
                              ? [
                                  _c("p", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.getValueLabel(item.value.text)
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  item.value.description
                                    ? _c("p", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(item.value.description) +
                                            "\n                            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "import-buttons" },
                                    _vm._l(
                                      _vm
                                        .filteredAccountingCodes(
                                          item.valueFrom.params
                                        )
                                        .slice(0, 3),
                                      function(accountingCode) {
                                        return _c(
                                          "div",
                                          {
                                            key: accountingCode.code,
                                            staticClass: "import-buttons__item"
                                          },
                                          [
                                            _c(
                                              "CompassTooltip",
                                              {
                                                attrs: {
                                                  content:
                                                    _vm.localizedTexts
                                                      .copyValue,
                                                  placement: "bottom"
                                                }
                                              },
                                              [
                                                _c(
                                                  "CompassTag",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:copy",
                                                        value:
                                                          accountingCode.code,
                                                        expression:
                                                          "accountingCode.code",
                                                        arg: "copy"
                                                      },
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:success",
                                                        value: _vm.onCopy,
                                                        expression: "onCopy",
                                                        arg: "success"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "import-buttons__tag"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          accountingCode.code
                                                        ) +
                                                        " -\n                                            " +
                                                        _vm._s(
                                                          accountingCode.label
                                                        ) +
                                                        "\n                                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _vm.filteredAccountingCodes(
                                    item.valueFrom.params
                                  ).length > 3
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "import-buttons__tertiary",
                                          on: {
                                            click: function($event) {
                                              return _vm.showModalAccountingCodes(
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.localizedTexts.showAllValues
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : [
                                  _c("p", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.getValueLabel(item.value.text)
                                        ) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  item.value.description
                                    ? _c("p", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(item.value.description) +
                                            "\n                            "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.value.subtext
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "subtext typographies-paragraph-small-regular"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.value.subtext) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.value.link
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "typographies-paragraph-small-semibold",
                                          attrs: {
                                            href: item.value.link.href,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.value.link.label) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                          ],
                          2
                        )
                      ]
                ],
                2
              )
            }),
            0
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }